// components/CategoryGrid/CategoryGrid.jsx
import { useNavigate } from 'react-router-dom';
import './CategoryGrid.css';
import { SearchComponent } from '../Search/SearchComponent';

const categories = [
  { icon: 'assets/icons/mobiles_category.png', name: 'Mobiles', query: 'Mobiles' },
  { icon: 'assets/icons/bike_category.png', name: 'Bikes', query: 'Bikes' },
  { icon: 'assets/icons/car_category.png', name: 'Cars', query: 'Cars' },
  { icon: 'assets/icons/furniture_category.png', name: 'Furniture', query: 'Furniture' },
  { icon: 'assets/icons/electronics_category.png', name: 'Electronics & Appliances', query: 'Electronics & Appliances' },
  { icon: 'assets/icons/Fashion.png', name: 'Fashion', query: 'Fashion' },
  { icon: 'assets/icons/books_sports_category.png', name: 'Books, Sports & Hobbies', query: 'Books, Sports & Hobbies' },
  { icon: 'assets/icons/properties_category.png', name: 'Properties', query: 'Properties' },
  { icon: 'assets/icons/services_category.png', name: 'Services', query: 'Services' }
];

export const CategoryGrid = ({searchQuery, setSearchQuery, onSearch, onCategorySelect}) => {
  const navigate = useNavigate();
  return (
    <section className="category-section">
      <div className="container">
        <h2 className="section-title">What are you looking for today?</h2>
        <SearchComponent 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSearch={onSearch}
        />
        <p className="section-subtitle">Explore by category</p>
        <div className="category-grid" >
          {categories.map((cat) => (
            <div
              key={cat.query}
              className="category-item"
              onClick={() => onCategorySelect(cat.query)}
            >
              <div className="icon-wrapper">
                {/* REPLACE ICON HERE: <img src={cat.myCustomIcon} alt={cat.name} /> */}
                <span className="category-grid-cat-icon"><img src={cat.icon} alt={cat.name} /></span>
              </div>
              <span className="cat-name">{cat.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};